/**
 * The map shows one layer at a time, and each brings its own furniture:
 *
 *   1. the trip's footage, pinned where it was taken, with the day tabs and the time dial;
 *   2. places worth knowing about (nothing yet, and it says so rather than hiding);
 *   3. the danger map, painted by sector, with its legend.
 *
 * One at a time because together they were three answers on one screen: the dial's pins over a
 * choropleth read as "these photographs were taken somewhere dangerous", which is not what either
 * layer says.
 */
export type Layer = 1 | 2 | 3;

export const LAYER_NAMES: Record<Layer, string> = { 1: "Footage", 2: "Places", 3: "Safety" };

const LAYERS: Layer[] = [1, 2, 3];

/** The segmented control that picks the layer. The page decides what each one shows. */
export function MapLayers({
  layer,
  onLayer,
  className = "map-layers",
}: {
  layer: Layer;
  onLayer: (l: Layer) => void;
  /** Lifts it clear of the dial on a phone, where the dial is showing. */
  className?: string;
}) {
  return (
    <div className={className} role="group" aria-label="Map layer">
      {LAYERS.map((l) => (
        <button key={l} type="button" aria-pressed={l === layer} onClick={() => onLayer(l)}>
          {LAYER_NAMES[l]}
        </button>
      ))}
    </div>
  );
}
